import React from 'react';
import './App.css';
import {Route, Routes} from "react-router-dom";
import {DespreNoiPage} from "./Pages/despre-noi";
import {PAGES} from "./Components/Navbar/Navbar";
import ProiecteComunicatePage from "./Pages/proiecte/ProiecteComunicatePage";
import AdminProiecteComunicatePage from "./Pages/proiecte/AdminProiecteComunicatePage";
import {ActivitatiPage} from "./Pages/activitati";
import {ContactPage} from "./Pages/contact";
import {OrganizatiiMembrePage} from "./Pages/organizatii-membre";
import {MembriDeSindicatPage} from "./Pages/membri-de-sindicat";
import {JuridicPage} from "./Pages/juridic";
import {MediaPage} from "./Pages/media";
import {ProiectePage} from "./Pages/proiecte";
import {BibliotecaVirtualaPage} from "./Pages/juridic/biblioteca-virtuala";
import {LegislatiePage} from "./Pages/juridic/legislatie";
import {CCMPage} from "./Pages/juridic/ccm";
import {PodcastPage} from "./Pages/media/podcast";
import {GalerieFotoPage} from "./Pages/media/galerie-foto";
import {ComunicateDePresaPage} from "./Pages/media/comunicate-de-presa";
import {AparitiiInPresaPage} from "./Pages/media/aparitii-in-presa";
import {GalerieVideoPage} from "./Pages/media/galerie-video";
import {JusticeAdminPage} from "./Pages/juridic/legislatie/admin";
import { initializeApp } from "firebase/app";
import { CCMAdminPage } from './Pages/juridic/ccm/admin';
import { ComunicatPage } from './Pages/media/comunicate-de-presa/Comunicat';
import { AdminPressPage } from './Pages/media/comunicate-de-presa/admin';
import { PodcastEpisodePage } from './Pages/media/podcast/Episode';
import { AdminPodcastPage } from './Pages/media/podcast/admin';
import { AdminProiectePage } from './Pages/proiecte/admin';
import { AdminContactPage } from './Pages/contact/admin';
import { IstoricPage } from './Pages/istoric';
import { AdminIstoricPage } from './Pages/istoric/admin';
import { MisiuneSiObiectivePage } from './Pages/misiune';
import { AdminMisiunePage } from './Pages/misiune/admin';
import { ConducerePage } from './Pages/conducere';
import { AdminConducerePage } from './Pages/conducere/admin';
import { OrganizatiePage } from './Pages/organizatii-membre/Organizatie';
import { AdminOrganizatiiMembrePage } from './Pages/organizatii-membre/admin';
import { StatutPage } from './Pages/statut';
import { AdminStatutPage } from './Pages/statut/admin';
import { MaintenancePage } from './Pages/maintenance';
import { useMaintenanceRedirect } from './Components/useMaintenance';
import AdminSmartOrdersPage from "./Pages/admin/smart-orders";
import AdminInstitutesPage from "./Pages/admin/institutes/AdminInstitutesPage";
import {AdminDespreNoiPage} from "./Pages/despre-noi/admin";
import { AdminMembriDeSindicatPage } from "./Pages/membri-de-sindicat/admin";

function App() {
  // useMaintenanceRedirect()
  return (
    <div className="App">
        <Routes>
            <Route path="/" element={<DespreNoiPage/>}/>
            <Route path={PAGES.DESPRE_NOI} element={<DespreNoiPage/>}/>
            <Route path={`admin/${PAGES.DESPRE_NOI}`} element={<AdminDespreNoiPage/>}/>

            <Route path={PAGES.ORGANIZATII_MEMBRRE} element={<OrganizatiiMembrePage/>}/>
            <Route path={PAGES.MEMBRI_DE_SINDICAT} element={<MembriDeSindicatPage/>}/>
            <Route path={`admin/${PAGES.MEMBRI_DE_SINDICAT}`} element={<AdminMembriDeSindicatPage/>}/>
            <Route path={PAGES.ACTIVITATI} element={<ActivitatiPage/>}/>
            <Route path={PAGES.JURIDIC} element={<JuridicPage/>}/>

            <Route path="/organizatii" element={<OrganizatiiMembrePage />} />
            <Route path="/organizatii/:id" element={<OrganizatiePage />} />

    {/* Pagini admin */}
            <Route path="/admin/organizatii" element={<AdminOrganizatiiMembrePage />} />

            <Route path={PAGES.MEDIA} element={<MediaPage/>}/>

            <Route path={PAGES.STATUT} element={<StatutPage/>}/>
            <Route path={`admin/${PAGES.STATUT}`} element={<AdminStatutPage/>}/>

            <Route path={PAGES.ISTORIC} element={<IstoricPage/>}/>
            <Route path={`admin/${PAGES.ISTORIC}`} element={<AdminIstoricPage/>}/>

            <Route path={PAGES.MISIUNI_SI_OBIECTIVE} element={<MisiuneSiObiectivePage/>}/>
            <Route path={`admin/${PAGES.MISIUNI_SI_OBIECTIVE}`} element={<AdminMisiunePage/>}/>

            <Route path={PAGES.CONDUCRE} element={<ConducerePage/>}/>
            <Route path={`admin/${PAGES.CONDUCRE}`} element={<AdminConducerePage/>}/>

            <Route path={PAGES.PROIECTE} element={<ProiectePage/>}/>
            <Route path={`admin/${PAGES.PROIECTE}`} element={<AdminProiectePage/>}/>

            <Route path={PAGES.CONTACT} element={<ContactPage/>}/>
            <Route path={`admin/${PAGES.CONTACT}`} element={<AdminContactPage/>}/>

            <Route path={PAGES.BIBLIOTECA_VIRTUALA} element={<BibliotecaVirtualaPage/>}/>

            <Route path={PAGES.LEGISLATIE} element={<LegislatiePage/>}/>
            <Route path={`admin/${PAGES.LEGISLATIE}`} element={<JusticeAdminPage/>}/>

            <Route path={PAGES.CCM} element={<CCMPage/>}/>
            <Route path={`admin/${PAGES.CCM}`} element={<CCMAdminPage/>}/>

            <Route path={PAGES.PODCAST} element={<PodcastPage/>}/>
            <Route path="/podcast/:id" element={<PodcastEpisodePage />} />
            <Route path={`admin/${PAGES.PODCAST}`} element={<AdminPodcastPage/>}/>


            <Route path={PAGES.COMUNICATE_DE_PRESA} element={<ComunicateDePresaPage/>}/>
            <Route path={`/comunicate/:id`} element={<ComunicatPage />} />
            <Route path={`admin/${PAGES.COMUNICATE_DE_PRESA}`} element={<AdminPressPage/>}/>

            <Route path={PAGES.APARITII_IN_PRESA} element={<AparitiiInPresaPage/>}/>
            <Route path={PAGES.GALERIE_FOTO} element={<GalerieFotoPage/>}/>
            <Route path={PAGES.GALERIE_VIDEO} element={<GalerieVideoPage/>}/>
            <Route path={"/maintenance"} element={<MaintenancePage/>}/>
            <Route path="/proiecte" element={<ProiectePage/>} />
            <Route path="/proiecte/comunicate" element={<ProiecteComunicatePage />} />
            <Route path="/admin/proiecte/comunicate" element={<AdminProiecteComunicatePage />} />
            <Route path="/admin/smart-orders" element={<AdminSmartOrdersPage />} />
            <Route path="/admin/institute" element={<AdminInstitutesPage />} />
        </Routes>
    </div>
  );
}

export default App;
